import { SyntheticEvent } from 'react';
import { useTheme } from '@mui/material/styles';
// material-ui
import { Alert, AlertTitle, Button, Fade, Grow, IconButton, Slide, SlideProps, SxProps, Theme } from '@mui/material';
import MuiSnackbar from '@mui/material/Snackbar';

// assets
import CloseIcon from '@mui/icons-material/Close';

import { KeyedObject } from 'types';
import { useDispatch, useSelector } from 'store';
import { closeSnackbar } from 'store/slices/snackbar';

// animation function
function TransitionSlideLeft(props: SlideProps) {
    return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props: SlideProps) {
    return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props: SlideProps) {
    return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}

function GrowTransition(props: SlideProps) {
    return <Grow {...props} />;
}

// animation options
const animation: KeyedObject = {
    SlideLeft: TransitionSlideLeft,
    SlideUp: TransitionSlideUp,
    SlideRight: TransitionSlideRight,
    SlideDown: TransitionSlideDown,
    Grow: GrowTransition,
    Fade
};

const sxAlertOutlined = {
    bgcolor: 'background.paper'
};

const sxAlertFilledSuccess = {
    bgcolor: 'success.dark'
};
const sxAlertFilledError = {
    bgcolor: 'error.main'
};
const sxAlertFilledWarning = {
    bgcolor: 'warning.main'
};
// ==============================|| SNACKBAR ||============================== //

const Snackbar = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const snackbar = useSelector((state) => state.snackbar);
    const { actionButton, anchorOrigin, alert, close, message, open, transition, variant, autoHideDuration, handleSnackbarClosed } =
        snackbar;

    const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        handleSnackbarClosed && handleSnackbarClosed();

        dispatch(closeSnackbar());
    };

    const getAlertStyle = () => {
         // theme.palette.warning.main
        if (alert.variant === 'outlined') {
            return sxAlertOutlined;
        }
        if (alert.variant === 'filled') {
            if (alert.color === 'success') {
                return sxAlertFilledSuccess;
            } 
            
            if (alert.color === 'error') {
                return sxAlertFilledError;
            }
            if (alert.color === 'warning') {
                return sxAlertFilledWarning;
            }
        }
        return {};
    };

    return (
        <>
            {/* default snackbar */}
            {variant === 'default' && (
                <MuiSnackbar
                    anchorOrigin={anchorOrigin}
                    open={open}
                    autoHideDuration={autoHideDuration}
                    onClose={handleClose}
                    message={message}
                    TransitionComponent={animation[transition]}
                    action={
                        <>
                            <Button color="secondary" size="small" onClick={handleClose}>
                                UNDO
                            </Button>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} sx={{ mt: 0.25 }}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    }
                />
            )}

            {/* alert snackbar */}
            {variant === 'alert' && (
                <MuiSnackbar
                    TransitionComponent={animation[transition]}
                    anchorOrigin={anchorOrigin}
                    open={open}
                    autoHideDuration={autoHideDuration}
                    onClose={handleClose}
                >
                    <Alert
                        // severity='success'
                        variant={alert.variant}
                        color={alert.color}
                        action={
                            <>
                                {actionButton !== false && (
                                    <Button size="small" onClick={handleClose} sx={{ color: 'background.paper' }}>
                                        UNDO
                                    </Button>
                                )}
                                {close !== false && (
                                    <IconButton sx={{ color: 'background.paper' }} size="small" aria-label="close" onClick={handleClose}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </>
                        }
                        sx={getAlertStyle()}
                    >
                        {/* <AlertTitle>{alert.color?.toString()} </AlertTitle> */}
                        {message}
                    </Alert>
                </MuiSnackbar>
            )}
        </>
    );
};

export default Snackbar;
